"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getColorBorder = void 0;
var _constants = require("../constants");
const getColorBorder = (param)=>{
    let { background, theme } = param;
    return _constants.WHITE_COLORS.includes(background) ? "1px solid ".concat(theme.palette.grey[200]) : undefined;
};
exports.getColorBorder = getColorBorder;
